import { createContentfulProps } from "frontend/contentful/lib/create-contentful-props";
import { TeaseRowCourseCardsEntry } from "frontend/contentful/schema/blocks";
import { createCourseTeaseProps } from "./course-tease.props";
import { createUseSearchProps } from "../../utils/use-search.props";
import { useSearch } from "frontend/hooks/use-search";
import { createSearchCourseTease } from "frontend/contentful/search/search-course-tease";
import { CourseCardsProps } from "design-system/sites/online/components/course-card-tease/course-card-tease";
import { filterUndefined } from "design-system/utils/filter-undefined";

export interface CourseCardTeases {
  teases: Array<CourseCardsProps>;
}

export const createTeaseRowCourseCardsProps = createContentfulProps<
  TeaseRowCourseCardsEntry,
  CourseCardTeases
>(({ entry }) => {
  const props: CourseCardTeases = {
    teases: [],
  };

  entry.fields.teasesManual?.forEach((course) => {
    const programCardTeaseProps = createCourseTeaseProps(course);
    if (programCardTeaseProps) {
      props.teases?.push(programCardTeaseProps);
    }
  });

  const { courseType } = entry.fields;

  const searchProps = createUseSearchProps(entry.fields.teasesQuery);

  const { data } = useSearch(searchProps, {
    enabled: entry.fields.teasesQuery ? true : false,
  });

  if (entry.fields.teasesQuery) {
    props.teases =
      data?.hits
        .map((item) => createSearchCourseTease(item))
        .filter((item) => {
          const { isMultiCourse } = item || {};
          if (courseType === "single-courses") return !isMultiCourse;
          if (courseType === "multi-courses") return isMultiCourse;
          return true;
        })
        .filter(filterUndefined) || [];
  }

  // Filter out teases with a start date that had already passed except for "On Demand" sessions
  if (props.teases) {
    props.teases = props.teases.filter((tease) => {
      if (!tease.sessions || tease.sessions.length === 0) return true;

      const now = new Date().getTime();
      const upcomingSession = tease.sessions.find((session) => {
        if (session.sessionType?.trim().toLowerCase() === "on demand") {
          return true;
        }
        if (!session.startDate) return false;
        const sessionDate = new Date(session.startDate).getTime();
        return sessionDate >= now;
      });

      return Boolean(upcomingSession);
    });
  }

  return props;
});
